import { Link } from '@tanstack/react-router';

interface BrandProps {
  link: string;
  variant?: 'dark' | 'light';
  showText?: boolean;
  size?: 'default' | 'compact';
}

const Brand = ({
  link,
  variant = 'dark',
  showText = true,
  size = 'default',
}: BrandProps) => {
  const textColor =
    variant === 'dark' ? 'text-foreground-primary' : 'text-foreground-inverse';
  const isCompact = size === 'compact';
  const logoHeight = isCompact ? 'h-9' : 'h-11';

  return (
    <Link
      to={link}
      className={`flex items-center ${isCompact ? 'justify-center' : 'gap-3'}`}
    >
      <img
        src="/logo-new.png"
        alt="Assureli Logo"
        className={`${logoHeight} w-auto object-contain transition-all duration-300`}
      />
      {showText && !isCompact && (
        <span
          className={`font-heading text-[28px] font-normal tracking-[2px] ${textColor}`}
        >
          ASSURELI
        </span>
      )}
    </Link>
  );
};

export default Brand;
